import CometMarquee from 'comet-marquee';
// import 'comet-marquee/dist/comet-marquee.css';

const capabilitiesMarqueeArr = document.querySelectorAll('.capabilities-marquee');
capabilitiesMarqueeArr.forEach((capabilitiesMarqueeEl, i) => {
  const capabilitiesMarquee = new CometMarquee(capabilitiesMarqueeEl, {
    speed: 50,
    pauseOnHover: true,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 3,
    forceAnimation: true,
    forceAnimationWidth: 2,
  });
})